// eslint-disable-next-line import/extensions
import { decodeHTML } from 'entities/lib/decode.js';

export const decode = decodeHTML;

export default decode;
